import { Card, CardTitle, CardHeader, CardContent, CardFooter, CardDescription } from "@/components/ui/card";
import { Button } from "@/app/v2/_components/button/button";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { Text } from "@/app/v2/_components/text/Text";
import { Column } from "@/app/v2/_components/column/Column";

type EmptyStateProps = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
  buttonIcon?: React.ReactNode;
  button2Text?: string;
  button2Link?: string;
  button2Icon?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
};

export const EmptyState = ({
  icon,
  title,
  description,
  buttonText,
  buttonLink,
  buttonIcon,
  button2Text,
  button2Link,
  button2Icon,
  children,
  className,
}: EmptyStateProps) => {
  return (
    <div className={cn("flex flex-col bg-transparent w-full sm:w-[400px] max-w-2xl", className)}>
      <Card className="border-none shadow-none bg-transparent flex flex-col gap-0 w-full">
        <CardHeader className="z-10 flex flex-col gap-0 text-foreground relative">
          {icon ? (
            <div className="relative">{icon}</div>
          ) : null}
          <Column noGap>
            <Text fat>{title}</Text>
            <Text base subdued>{description}</Text>
          </Column>
        </CardHeader>

        {children ? (
          <CardContent>{children}</CardContent>
        ) : null}

        {buttonLink || button2Link ? (
          <CardFooter className="z-10 flex flex-col gap-2">
            {buttonLink ? (
              <Link href={buttonLink}>
                <Button variant="default" className="z-10">
                  {buttonIcon}
                  {buttonText}
                </Button>
              </Link>
            ) : null}

            {button2Link ? (
              <>
                or
                <Link href={button2Link}>
                  <Button variant="secondary" className="z-10">
                    {button2Icon}
                    {button2Text}
                  </Button>
                </Link>
              </>
            ) : null}
          </CardFooter>
        ) : null}
      </Card>
    </div>
  );
};
